'use strict';

import './scss/apptek.scss';
import heimdall_woo from './js/heimdall-child-theme-woo.js';
import heimdall_wp from './js/heimdall-child-theme-wp.js';

$(document).ready(function($) {
  heimdall_wp();
  heimdall_woo();
});
